import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { APP_ROUTES } from 'src/enums';
import HomePage from 'src/pages/homePage';
import LoginPage from 'src/pages/loginPage';

import ErSummaryPage from './pages/erSummaryPage';
import LabPage from './pages/labPage';
import MedicalHistoryPage from './pages/medicalHistoryPage';
import RadiologyPage from './pages/radiologyPage';
import ReleaseDocsPage from './pages/releaseDocsPage';
import VisitSummaryPage from './pages/visitSummaryPage';
import { NoMatchScreen } from './screens/noMatch';

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={`${APP_ROUTES.LOGIN}`} element={<LoginPage />} />

        <Route path={`${APP_ROUTES.HOME}`} element={<HomePage />} />

        <Route
          path={`${APP_ROUTES.MEDICAL_HISTORY}`}
          element={<MedicalHistoryPage />}
        />

        <Route
          path={`${APP_ROUTES.RELEASE_DOCS}`}
          element={<ReleaseDocsPage />}
        />

        <Route
          path={`${APP_ROUTES.VISIT_SUMMARY}`}
          element={<VisitSummaryPage />}
        />

        <Route path={`${APP_ROUTES.ER_SUMMARY}`} element={<ErSummaryPage />} />

        <Route path={`${APP_ROUTES.RADIOLOGY}`} element={<RadiologyPage />} />

        <Route path={`${APP_ROUTES.LAB}`} element={<LabPage />} />

        <Route path="*" element={<NoMatchScreen />} />
      </Routes>
    </BrowserRouter>
  );
}
